const SectionTitle = ({ title, description = null }) => {
    return (
        <div className="section-title">
            <h2>{title}</h2>
            <p>{description}</p>
        </div>
    );
};

export default SectionTitle;